import { render, staticRenderFns } from "./fancyEditor.vue?vue&type=template&id=1f5c01bc&"
import script from "./fancyEditor.vue?vue&type=script&lang=js&"
export * from "./fancyEditor.vue?vue&type=script&lang=js&"
import style0 from "./fancyEditor.vue?vue&type=style&index=0&id=1f5c01bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fancyEditor.vue"
export default component.exports